import { FC, useState } from 'react';
import {
  Tooltip as MuiTooltip,
  type TooltipProps,
  ClickAwayListener,
  useMediaQuery,
  useTheme,
} from '@mui/material';

const tooltipStyles = {
  tooltip: {
    sx: {
      fontSize: '14px',
      borderRadius: '3px',
      background: 'black',
      color: 'white',
    },
  },
  arrow: { sx: { color: 'black' } },
};

const Tooltip: FC<TooltipProps> = (props) => {
  const { placement, title, children, ...rest } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);

  if (isMobile) {
    return (
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <span>
          <MuiTooltip
            placement={placement}
            title={title}
            arrow
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            slotProps={tooltipStyles}
            {...rest}
          >
            <span onClick={() => setOpen((prev) => !prev)}>{children}</span>
          </MuiTooltip>
        </span>
      </ClickAwayListener>
    );
  }

  return (
    <MuiTooltip
      placement={placement}
      title={title}
      arrow
      slotProps={tooltipStyles}
      {...rest}
    >
      {children}
    </MuiTooltip>
  );
};

export default Tooltip;
